import type { ComponentType } from 'react';

export type UserProfile = {
	/** The email address of the user */
	email: string;

	/** The user's name */
	name: string;

	/** The current tenant identifier */
	t?: string;

	circle?: string;

	/** Alternate tenants available to the user */
	ta?: string;

	role?: string[];
	/** The current user's identifier, a guid that will not change per identity. Will be the same across tenants. */
	sub: string;

	kind?: 'guest' | 'user' | 'system';

	listId?: number;

	listType?: string;

	pin?: string;

	ori?: string;
};

export enum ChildOnlyOption {
	RedirectToRoot = 'Root',
	NoClick = 'NoClick'
}
export interface IRoute {
	title: string;
	PageComponent: ComponentType;

	/** allow this page route to be accessed anonymously */
	anonymous?: boolean;

	/** optional props to pass to the page component */
	pageProps?: any;

	requireFlags?: Array<string>;

	/** optional props to pass to build breadcrumbs */
	icon?: string;
	parentRoute?: string;

	/** optional prop for paths which requireSubPath */
	childOnly?: ChildOnlyOption;
}
